import * as basicScroll from 'basicscroll';

export let mixinAnimation = {
    props: {
        isActive: Boolean
    },
    watch: {
        isActive() {
            if (this.isActive) this.createAnimation();
            else this.destroyAnimation();
        }
    },
    methods: {
        createScroll(from = 'top-bottom', to = 'top-middle') {
            from;
            to;
            this.timeline.progress(0.0001);
            const instance = basicScroll.create({
                elem: this.$refs.animation,
                from,
                to,
                props: {
                    playback: {
                        from: 0,
                        to: 1
                    }
                },
                inside: (instance, percentage, props) => {
                    instance;
                    percentage;
                    props;
                    this.timeline.pause();
                    this.timeline.progress(percentage / 100);
                },
                outside: (instance, percentage, props) => {
                    instance;
                    percentage;
                    props;
                    this.timeline.pause();
                    if (percentage < 0) {
                        this.timeline.progress(0.0001);
                    } else if (percentage > 100) {
                        this.timeline.progress(1);
                    }
                }
            });
            this.instance = instance;
            this.instance.start();
            this.isInited = true;
        },
        destroyAnimation() {
            if (this.instance) {
                this.instance.destroy();
                this.instance = null;
            }
            if (this.BscInstance) {
                this.BscInstance.destroy();
                this.BscInstance = null;
            }
            if (this.timeline) {
                this.timeline.kill();
                this.timeline = null;
            }
            this.isInited = false;
        }
    },
    mounted() {
        if (this.isActive) this.createAnimation();
    },
    updated() {
        if (this.isActive) this.createAnimation();
    },
    beforeUpdate() {
        this.destroyAnimation();
    }
};
